module.exports = __webpack_public_path__ + "static/media/vis14.1dd173a0.jpeg";